import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export type TagStatusType = 'default' | 'success' | 'danger' | 'warning' | 'neutral' | 'warning-dark';

@Component({
  selector: 'cx-tag',
  imports: [CommonModule, TranslateModule],
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
})
export class TagComponent {
  @Input() type: TagStatusType = 'default';
  @Input() variant: 'default' | 'outline' | 'rounded' = 'default';
  @Input() icon = '';
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() iconPosition: 'left' | 'right' = 'right';
  @Input() disabled = false;

  get hostClasses(): string[] {
    const classes: string[] = [this.type, this.variant];

    switch (this.size) {
      case 'sm':
        classes.push('tag-sm');
        break;
      case 'lg':
        classes.push('tag-lg');
        break;
    }

    if (this.icon) {
      classes.push(this.iconPosition === 'right' ? 'tag-icon-r' : 'tag-icon-l');
    }

    return classes;
  }
}
